import React, { useState, useEffect, useRef } from "react";
import SubTask from "../subtasks/SubTask";
import { Draggable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { completeTask } from "../../redux/reducers/TodoManipulation/projectReducer";
import ContextMenu from "../contextMenu/ContextMenuComponent";
import { toggleShowProjectContextMenu } from "../../redux/actions/showProjectContextMenuAction";
import { editTaskInFirebase } from "../../redux/actions/TodoManipulation/editTaskInFirebaseAction";
import { Tooltip } from 'react-tooltip';
import dayjs from "dayjs";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";
import { findByIdInTreeList } from "../../utils/tree";

const Task = (props) => {
    const { task, zoomLevel, taskIndex, toggleShowModal, toggleShowDateModal, toggleShowDeleteModal, parent, context = 'default' } = props;
    const { title, id, color, $id, isCompleted, dueDate } = task;
    const taskDueDate = dayjs(dueDate).format('ll');
    const dispatch = useDispatch();
    const showDueDate = useSelector((state) => state.userSettings.showDueDate);
    const showTaskSize = useSelector((state) => state.userSettings.showVisualSize);
    const showTaskProgress = useSelector((state) => state.userSettings.showTaskProgress);
    const [menuPosition, setMenuPosition] = useState({ position: 'absolute', top: 0, left: 0 });
    const [isHovered, setIsHovered] = useState(false);
    const showAllSubtasks = useSelector((state) => state.showAllSubtasks);
    const taskToggleStates = useSelector((state) => state.taskToggleState);
    const previousGlobalState = useRef(showAllSubtasks);
    const isMobile = useIsMobile();
    
    // Get toggle state from Redux or fall back to global state
    const showChildren = taskToggleStates[id] !== undefined ? taskToggleStates[id] : showAllSubtasks;
    const projects = useSelector((state) => state.taskList.data);
    const unfilteredTodo = findByIdInTreeList(projects, id);
    const tooltipId = `tooltip-completed-${context}-${task.$id}`;
    const handleMouseOver = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleMoreToggle = () => {
        const newState = !showChildren;
        dispatch({ 
            type: 'SET_TASK_TOGGLE_STATE', 
            payload: { taskId: id, showChildren: newState } 
        });
    };

    const countCompletedTasks = (children) => {
        let totalTasks = 0;
        let completedTasks = 0;

        if (children && children.length > 0) {
            for (var child of children) {
                totalTasks++;
                if (child.isCompleted) {
                    completedTasks++;
                }
            }
        }
        const returnValue = `${completedTasks}/${totalTasks}`;
        return returnValue;
    }


    const updateIsCompleted = async () => {
        console.log("IsCompleted", isCompleted);

        const json = {
            id: id,
            Title: title,
            IsCompleted: !isCompleted,
            HasDescription: (isNullOrUndefined(task.hasDescription)) ? false.toString() : task.hasDescription,
            Description: task.description,
            HasDueDate: (isNullOrUndefined(task.hasDueDate)) ? false.toString() : task.hasDueDate,
            DueDate: task.dueDate,
            VisualSize: task.visualSize.toString(),
            HasSnoozedUntil: (isNullOrUndefined(task.hasSnoozedUntil)) ? false.toString() : task.hasSnoozedUntil,
            SnoozedUntil: task.snoozedUntil
        }

        await dispatch(editTaskInFirebase(json));
    };

    function isNullOrUndefined(value) {
        return value === undefined || value === null;
    }

    useEffect(() => {
        // If global toggle changed, clear all manual toggles
        if (previousGlobalState.current !== showAllSubtasks) {
            dispatch({ type: 'CLEAR_ALL_TASK_TOGGLE_STATES' });
            previousGlobalState.current = showAllSubtasks;
        }
    }, [showAllSubtasks]); 

    const calculatePercentageCompleted = (children) => {
        if (!children || children.length === 0) {
            return 0;
        }

        const completedTasks = children.filter((task) => task.isCompleted);
        const percentage = (completedTasks.length / children.length) * 100;

        return percentage;
    };
    const showProjectContextMenu = useSelector(
        (state) => state.showProjectContextMenu[task.$id]
    );
    const toggleContextMenu = (event, projectId) => {
        dispatch(toggleShowProjectContextMenu(projectId));
    };

    const getTaskColor = () => {
        if (task && task.color) {
            return task.color.hexString;
        } else if (parent && parent.color) {
            return parent.color.hexString;
        } else {
            return "#80C3E9";
        }
    };
    const [taskColor, setTaskColor] = useState(getTaskColor());

    useEffect(() => { 
        setTaskColor(getTaskColor()); 
    }, [task]);

    return (
        <Draggable draggableId={$id} index={taskIndex}>
            {(provided, snapshot) => {
                const draggableStyle = {
                    ...provided.draggableProps.style,
                }
                if (snapshot.isDragging) {

                    if (snapshot.isDragging) {
                        draggableStyle.left = `${provided.draggableProps.style.offsetLeft}px`;
                        draggableStyle.top = `${provided.draggableProps.style.offsetTop}px`;
                    }
                }
                return (
                    <div
                        className="gt-task task"
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        onClick={(event) => { toggleShowModal(task.id, event); event.stopPropagation(); }}
                    >
                        <div
                            className="gt-task__color"
                            style={{ background: taskColor ? taskColor : "#80C3E9" }}
                        ></div>
                        <a data-tooltip-id={tooltipId}>
                            <input
                                className={isHovered ? "gt-task__completed gt-task-completed-background-checked" : "gt-task__completed"}
                                type="checkbox"
                                aria-label="Task completed?"
                                onChange={updateIsCompleted}
                                checked={isCompleted}
                                onMouseOver={handleMouseOver}
                                onMouseLeave={handleMouseLeave}
                            />
                        </a>
                        <Tooltip id={tooltipId}>Mark as completed</Tooltip>
                        {task.type !== 0 && (
                            <svg
                                className="gt-task__group-icon"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <use xlinkHref="#globaltasks-svg-folder"></use>
                            </svg>
                        )}
                        <p className="gt-task__title">{title}</p>
                        {task.children.length > 0 && (
                            <button
                                className="gw-icon-button gw-icon-button--icon"
                                aria-label="more"
                                onClick={() => handleMoreToggle()}
                            >
                                <i className="gw-icon-button__icon gw-button__icon--chevron-down"
                                    style={{ transform: showChildren ? '' : 'rotate(180deg)' }}
                                ></i>
                            </button>
                        )}
                        <div className="task-context-menu">
                            <button
                                className="gw-icon-button gw-icon-button--icon"
                                aria-label="more"
                                onClick={(event) => { toggleContextMenu(event, task.$id) }}
                            >
                                <i className="gw-icon-button__icon gw-button__icon--more"></i>
                            </button>
                            {showProjectContextMenu && (
                                <div className={isMobile ? ''
                                    : "gt-context-menu-activator gt-context-menu-activator--bottom-right"}>
                                    <ContextMenu
                                        todoId={task.id}
                                        type={task.type}
                                        parent={task.parent}
                                        todo={task}
                                        toggleShowModal={toggleShowModal}
                                        toggleShowDateModal={toggleShowDateModal}
                                        toggleShowDeleteModal={toggleShowDeleteModal}
                                    ></ContextMenu>
                                </div>
                            )}
                        </div>
                        <div className="gt-task__tags">
                            {(showDueDate && task.dueDate) && (
                            <div className="gt-task-tag">
                                <svg xmlns="http://www.w3.org/2000/svg">
                                    <use xlinkHref="#globaltasks-svg-calendar"></use>
                                </svg>
                                <p>{taskDueDate}</p>
                                </div>)}

                            {(showTaskProgress && task.children.length > 0) && (


                                <div className="gt-task-tag">
                                    <svg className="gt-task__group-icon" xmlns="http://www.w3.org/2000/svg">
                                        <use href="#globaltasks-svg-checklist" />
                                    </svg>
                                    {countCompletedTasks(unfilteredTodo.children)}
                                </div>

                            )}

                            {(showTaskSize && task.visualSize !== 0) && (
                            <div className="gt-task-tag gt-task-tag--align-right">
                                    <svg xmlns="http://www.w3.org/2000/svg">
                                        {task.visualSize === 1 && (
                                            <use xlinkHref="#globaltasks-svg-effort-medium"></use>
                                        )}
                                        {task.visualSize === 2 && (
                                            <use xlinkHref="#globaltasks-svg-effort-large"></use>
                                        )}
                                    </svg>
                                </div>)}


                        </div>
                        <div className="gt-subtasks">
                            {task.type === 1 && (
                                <div className="gt-subtasks__progress">
                                    <div
                                        className="gt-subtasks__percentage"
                                        style={{
                                            width: `${calculatePercentageCompleted(unfilteredTodo.children)}%`,
                                        }}
                                    ></div>
                                </div>
                            )}

                            {(showChildren) &&
                                task.children &&
                                task.children
                                    .slice()
                                    .sort((a, b) => {
                                        const aSiblingOrder = a.siblingOrder || 0;
                                        const bSiblingOrder = b.siblingOrder || 0;
                                        if (aSiblingOrder === bSiblingOrder) {
                                            return (a.globalPriority || 0) - (b.globalPriority || 0);
                                        }
                                        return aSiblingOrder - bSiblingOrder;
                                    })
                                    .map((subTask, index) => (
                                        <SubTask
                                            key={subTask.$id}
                                            task={subTask}
                                            taskIndex={index}
                                            zoomLevel={zoomLevel}
                                            toggleShowModal={toggleShowModal}
                                        />
                                    ))}
                        </div>
                    </div>
                );
            }}
        </Draggable>
    );
};

export default Task;
